<template>
  <div class="pay">
    <van-nav-bar title="饭卡充值" left-text="返回"
    right-text="充值记录"
    left-arrow @click-left="$router.go('-1')"
    @click-right="$router.push('chargelist')" />
    <div class="money">
      <p>卡片余额（元）</p>
      <p class="money-num">{{ balance }}</p>
    </div>
    <div v-if="showCharge==true" class="c-container topLg">
      <CTitle title="选择充值金额" />
      <ul class="pay-list">
        <li
          :class="toggleIndex === index ? 'active' : ''"
          v-for="(item, index) in payList"
          :key="index"
          @click="handleTooglePayList(index, item)"
        >
          {{ item }}元
        </li>
      </ul>
      <van-field
        v-model="money"
        class="topMd"
        type="number"
        label="金额"
        maxlength="10"
        required
        placeholder="请输入充值金额"
      />
      <div class="topMd">
        <van-button class="commonBtn" type="primary" block @click="handlePay">确认充值</van-button>
      </div>
      <!-- <p class="tip top">
        如遇充值故障，请拨打客服热线<a href="tel:0571-58001408" class="secondary">0571-58001408</a>
      </p> -->
    </div>

    <div v-show="showModal" class="modal" @click="showModal = false">
      <img src="../../../assets/images/live_weixin.png" alt="" />
    </div>
  </div>
</template>

<script>
import CTitle from '@/components/c-title'

import { Toast } from 'vant'

export default {
  data() {
    return {
      timer: null,
      balance: 0, // 余额
      showModal: false,
      showCharge:true,
      money: '10',
      studentInfo:{},
      toggleIndex: 0,

      payList: [10, 20, 50, 100, 200, 500]
    }
  },
  created() {
    this.timer = setInterval(() => {
      console.log(1)
      this.getMoney()
    }, 5000)
  },
  mounted() {
    // if (this.$route.query.money) {
    //   this.money = this.$route.query.money
    // }
    var sinfo = localStorage.getItem("currentChild");
        this.studentInfo = JSON.parse(sinfo);
        if(this.studentInfo.Studentid==""){
          Toast("未选定孩子")
          this.$router.push("/my");
          return;
        }
        // if(this.studentInfo.Lightid==""){
        //   Toast("未配置一卡通卡")
        //   return;
        // }
        if (this.studentInfo.Schoolid==50000154){
          this.showCharge = false
        } else {
          this.showCharge = true
        }
        this.getMoney()
  },
  beforeDestroy() {
    window.clearInterval(this.timer)
  },
  methods: {
    getMoney() {
      // if(this.studentInfo.Lightid==""){
      //   return
      // }
      console.log("schoolid",this.studentInfo)
      this.$http
        .json_post(this.$api.onecard.getcardmoney, {
          studentid:eval(this.studentInfo.Studentid),
          Lightid:this.studentInfo.Lightid,
          Schoolid:eval(this.studentInfo.Schoolid),
          Deviceno:this.studentInfo.Deviceid,
        })
        .then(data => {
          console.log(data)
          if (data.code == 0) {
            this.balance = data.data
          } else {
            Toast(data.msg)
          }
        })
        .catch(err => {
          Toast('服务器异常1')
        })
    },

    handlePay() {
      if (!this.money) return Toast('金额不能为空')
      if(this.studentInfo.Lightid==""){
          Toast("未配置一卡通卡")
          return;
        }
        
        // 微信端
        this.$http
        .json_post(this.$api.onecard.onecardcharge, {
          Studentid:eval(this.studentInfo.Studentid),
          Lightid:this.studentInfo.Lightid,
          Onecardno:this.studentInfo.Lightid,
          Studentname:this.studentInfo.Studentname,
          Schoolid:this.studentInfo.Schoolid,
          Schoolname:this.studentInfo.Schoolname,
          Gradeid:this.studentInfo.Gradeid,
          Gradename:this.studentInfo.Gradename,
          Classid:this.studentInfo.Classid,
          Classname:this.studentInfo.Classname,
          Paymoney:this.money
        })
        .then(data => {
          console.log(data)
          if (data.code == 0) {
            this.onBridgeReady(data.data)
          } else {
            Toast(data.msg)
          }
        })
        .catch(err => {
          Toast('服务器异常1')
        })
      
    },
    onBridgeReady(params) {
        var that = this
        //alert(JSON.stringify(params))
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId": params.Appid,  //公众号名称，由商户传入
            "timeStamp": params.Timestamp, //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            "nonceStr": params.Noncestr,  //支付签名随机串，不长于 32 位
            "package": "prepay_id="+params.Prepayid,//统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            "signType": 'MD5',  //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            "paySign": params.Paysign, //支付签名
          },
          function (res) {
            //alert(JSON.stringify(res))
            if (res.err_msg === "get_brand_wcpay_request:ok") {
              alert('支付成功！');
              that.$router.push({path: '/my'})
            } else if (res.err_msg === "get_brand_wcpay_request:fail") {
              Toast('支付失败！');
            }
          });
      },
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase()
      // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
      if (ua.indexOf('micromessenger') > -1) {
        return true // 是微信端
      } else {
        return false
      }
    },

    handleTooglePayList(index, item) {
      this.money = item
      this.toggleIndex = index
    }
  },
  components: {
    CTitle
  }
}
</script>

<style lang="scss" scoped>
.money {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100px;
  margin-top: 10px;
  color: #fff;
  text-align: center;
  background: linear-gradient(to right, #00ae83, #00c795);
  .money-num {
    margin-top: $top;
    font-size: 28px;
    span {
      font-size: 14px;
    }
  }
}

.pay {
  .pay-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: $topMd;

    li {
      width: 80px;
      height: 30px;
      margin-bottom: 13px;
      color: #333;
      font-size: $fontMd;
      line-height: 30px;
      text-align: center;
      border: 1px solid $border;

      &.active {
        color: $primary;
        border-color: $primary;
      }
    }
  }

  .tip {
    color: #9f9f9f;
    text-align: center;

    span {
      color: #004ea2;
    }
  }
}

.modal {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  img {
    width: 100%;
    padding: 0.6rem;
    box-sizing: border-box;
  }
}
</style>
